export default __webpack_public_path__ + "static/media/logo.e709817b.webp";